/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable arrow-body-style */

import React, { useState, useEffect } from "react";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import { getSequenceStartDateString } from "../../utils/tableUtils";
import {
  CustomDatePicker,
  CustomSelect,
  EllipsedText,
  ValidatingTextField,
} from "../FormComponents";
import { API } from "../../apis/api";
import {
  API_RESOURCE_URLS,
  DATE_FORMAT,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
} from "../../constants";
import { isPositiveInteger, isQuantityValid } from "../../utils/utils";
import { reasons, agencies } from "../../staticData";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { useErrorHandler } from "react-error-boundary";
import { buildErrorMessage } from "../../apis/calls";
import { Modal, Box } from "@material-ui/core";
import styles from "./AddVcFormMes4.module.css";

const AddVcFormMes4 = ({
  title,
  open,
  handleClose,
  plant,
  plantName,
  line,
  lineName,
  lineBackgroundColor,
  lastAsnGeneratedDate,
  updatePlanRows,
  skipToLastPage,
  cancelButtonText,
  submitButtonText,
}) => {
  const [vcs, setVcs] = useState({ loading: false, data: [] });
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(
    false
  );
  const { showPopup } = usePopupManager();
  const handleError = useErrorHandler();
  const [reason, setReason] = useState("");
  const [agency, setAgency] = useState("");
  const [
    displayVcCombinationNotUniqueError,
    setDisplayVcCombinationNotUniqueError,
  ] = useState(false);
  const [vc, setVc] = useState("");
  const [comment, setComment] = useState("");
  const [dayTarget, setDayTarget] = useState("");
  const [startDate, setStartDate] = useState(null);
  const isLucknowProlifePlant = plantName === 'Lucknow-Prolife'
  const parentName = isLucknowProlifePlant ? 'Part' : 'VC'

  const formatOptionsForSelect = (...options) =>
    options.map((option) => ({ value: option, label: option }));

  const getVcOptions = () =>
    formatOptionsForSelect(...vcs.data.map(({ vc }) => vc));

  const getDescriptionForVc = (vcData) => {
    const selectedVc = vcData && vcData.value;
    const selectedVcData = vcs.data.filter(({ vc }) => vc === selectedVc)[0];
    return selectedVcData ? selectedVcData.description : <strong>--</strong>;
  };

  const reasonOptions = formatOptionsForSelect(...reasons);
  const agencyOptions = formatOptionsForSelect(...agencies);

  const handleSelectionCurry = (setState) => (valueObject) =>
    setState(valueObject);

  const loadData = async (setState, url, params) => {
    try {
      const response = await API.get(url, {
        params: params,
      });
      setState({ loading: false, data: response.data });
    } catch (error) {
      console.error(buildErrorMessage(error));
      handleError(error);
    }
  };

  const loadVcs = async () => {
    return loadData(setVcs, API_RESOURCE_URLS.VC_DESCRIPTION, {
      line,
      plant,
    });
  };

  const getSelectedVcCombination = () => ({    
    vc: vc && vc.value,    
  });

  const runPreSubmissionChecks = () => {    
    if (vc === null || startDate === null || dayTarget === null || reason === null || agency === null) {      
      setHighlightMandatoryFields(true);
      return false;
    } 
    return true;
  };

  const handleSubmit = async () => {
    const vcCombination = getSelectedVcCombination();
    try {      
      await API.put(`${API_RESOURCE_URLS.VC_QUANTITY}`, {
        plant,
        line,
        ...vcCombination,
        quantities: [{ date: startDate, quantity: Number(dayTarget) }],
        reason: reason.value,
        agency: agency.value,
        comment: comment,
      });
      handleClose();
      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: `${parentName} added.`,
        info: `${parentName} no: ${vc.label}`,
      });
      await updatePlanRows();
      skipToLastPage();
    } catch (error) {
      console.error(buildErrorMessage(error));
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: isLucknowProlifePlant ? DISPLAY_MESSAGES.PART_ADD_FAILURE : DISPLAY_MESSAGES.VC_ADD_FAILURE,
        info: "Plan Revision failed.",
        error: error,
      });
    }
  };

  const resetState = async () => {
    setVc(null);
    setStartDate(null);
    setReason(null);
    setAgency(null);
    setComment(null);
    setDayTarget(null);
    setDisplayVcCombinationNotUniqueError(null);
    setHighlightMandatoryFields(null);
  };

  useEffect(() => {
    if (open) {
      loadVcs();
    } else {
      resetState();
    }
  }, [open, plant, line]);

  return (
    <>
      <Modal open={open} onClose={handleClose} disableBackdropClick>
        <div className={styles.formContainer}>
          <div className={styles.formTitle}>
            <div>
              <span style={{ backgroundColor: "#EAEAEA" }}>{title}</span>
            </div>
            <div
              className={styles.formlLineDiv}
              style={{
                backgroundColor: lineBackgroundColor,
              }}
            />
          </div>
          <div className={styles.subHeading}>Note: ** NonMandatory fields</div>
          <Box className={styles.box_Line}>
            <div className={styles.gridcontainer_Basic}>
              <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                <label className={styles.label}>Plant</label>
              </div>
              <div className={styles.lineModalLeftInput_BasicInfo}>
                <input
                  aria-label="Plant"
                  className={styles.textfield}
                  value={plantName}
                  disabled
                />
              </div>
              <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                <label className={styles.label}>Line</label>
              </div>
              <div className={styles.lineModalLeftInput_BasicInfo}>
                <input
                  aria-label="Line"
                  className={styles.textfield}
                  value={lineName}
                  disabled
                />
              </div>
            </div>
          </Box>
          <div className={styles.BasicInfo_formSec}>
            <span class={styles.BasicInfo_rowTitle}>Basic Info</span>
            <Box className={styles.box_BasicInfo}>
              <div className={styles.gridcontainer_VCDetails}>
                <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                  <label className={styles.label}>{parentName} Number</label>
                </div>
                <div className={styles.lineModalLeftCustomSelect_BasicInfo}>
                  <CustomSelect
                    name="vc"
                    isMandatory
                    markIfUnselected={highlightMandatoryFields}
                    showError={displayVcCombinationNotUniqueError}
                    options={getVcOptions(vcs.data)}
                    className={clsx(styles.select, styles.sel1)}
                    value={vc}
                    onChange={handleSelectionCurry(setVc)}
                    maxMenuHeight={300}
                  />
                </div>
                <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                  <label className={styles.label}>VC Description</label>
                </div>
                <div className={styles.lineModalLeftLabel_VCDescription}>
                  <EllipsedText
                    value={getDescriptionForVc(vc, vcs.data)}
                    className={styles.description}
                  />
                </div>
              </div>
            </Box>
            <span class={styles.BasicInfo_rowTitle}>Plan details</span>
            <Box className={styles.box_BasicInfo}>
              <div className={styles.gridcontainer_VCDetails}>
                <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                  <label className={styles.label}>Start Date</label>
                </div>
                <div className={styles.lineModalCustomDatePicker}>
                  <CustomDatePicker
                    isMandatory
                    markIfUnselected={highlightMandatoryFields}
                    autoOk
                    inputVariant="outlined"
                    value={startDate}
                    onChange={(date) => {
                      setStartDate(date.format(DATE_FORMAT.ISO));
                    }}
                    inputProps={{
                      className: clsx(styles.select, styles.dateInput),
                    }}
                    emptyLabel="dd/mm/yyyy"
                    minDate={
                      process.env.NODE_ENV === "test"
                        ? moment(1)
                        : getSequenceStartDateString(lastAsnGeneratedDate)
                    }
                    format="DD/MM/yyyy"
                    data-testid="date-picker-div"
                  />
                </div>
                <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                  <label className={styles.label}>Day Target</label>
                </div>
                <div className={styles.lineModalLeftInput_BasicInfo}>                  
                  <ValidatingTextField
                    isMandatory
                    validationFn={isPositiveInteger}
                    markIfEmpty={highlightMandatoryFields}
                    isQuantityValid={isQuantityValid(dayTarget)}
                    aria-label="target-number-input"
                    validationHelperText={
                      DISPLAY_MESSAGES.POSITIVE_NUMBER_VALIDATION_WARNING
                    }
                    quantityValidationText={DISPLAY_MESSAGES.INVALID_INPUT}
                    variant="outlined"
                    value={dayTarget}
                    onChange={(e) => setDayTarget(e.target.value)}
                    placeholder="(Enter Target)"
                    className={styles.textField}
                    inputProps={{
                      className: styles.textInput,
                      "data-testid": "target-number-input",
                    }}
                    FormHelperTextProps={{
                      className: styles.helperText,
                    }}
                  />
                </div>                
              </div>              
            </Box>
            <span class={styles.BasicInfo_rowTitle}>Revision details</span>
            <Box className={styles.box_Revision}>
              <div className={styles.gridcontainer_VCDetails}>
                <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                  <label className={styles.label}>Reason</label>
                </div>
                <div className={styles.lineModalLeftCustomSelect_BasicInfo}>
                  <CustomSelect
                    name="reason"
                    isMandatory
                    markIfUnselected={highlightMandatoryFields}
                    options={reasonOptions}
                    className={clsx(styles.select, styles.sel1)}
                    value={reason}
                    onChange={handleSelectionCurry(setReason)}
                  />
                </div>
                <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                  <label className={styles.label}>Agency</label>
                </div>
                <div className={styles.lineModalLeftCustomSelect_BasicInfo}>
                  <CustomSelect
                    name="agency"
                    isMandatory
                    markIfUnselected={highlightMandatoryFields}
                    options={agencyOptions}
                    className={clsx(styles.select, styles.sel1)}
                    value={agency}
                    onChange={handleSelectionCurry(setAgency)}
                  />
                </div>
                <div className={styles.plantDetailsLeftLabel_BasicInfo}>
                  <label className={styles.label}>Comments **</label>
                </div>
                <div className={styles.lineModalLeftComment_BasicInfo}>
                  <textarea
                    className={styles.comments}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </Box>
          </div>

          <div className={styles.bottomRow}>
            <button
              type="button"
              className={styles.cancelBt}
              onClick={handleClose}
            >
              {cancelButtonText}
            </button>
            <span>
              <button
                type="button"
                onClick={(e) => {
                  if (e.detail > 1) {                    
                    return;
                  }
                  return runPreSubmissionChecks() && handleSubmit();
                }}
                className={styles.submitBt}
              >
                {submitButtonText}
              </button>
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

AddVcFormMes4.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  shopName: PropTypes.string,
  title: PropTypes.string.isRequired,
  lastAsnGeneratedDate: PropTypes.objectOf(moment),
  lineBackgroundColor: PropTypes.string.isRequired,
  updatePlanRows: PropTypes.func.isRequired,
  skipToLastPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
};

export default AddVcFormMes4;
